import React from 'react';
import image from '../images/laroye_cream.png';
import { Link } from 'react-router-dom';
import '../styles/footer.css'; // Import your CSS file 
const Footer = () =>{

 return(<table style={{ overflowY:'hidden', width: '100%', backgroundColor: 'black', color: '#fff', borderCollapse: 'collapse' }}>
 <tbody>
   <tr>
     <td><Link to="/"><img src={image} style={{ margin: '10px', marginBottom: '-10px' }} height='45px' maxWidth='160px' alt="joyfuel" /></Link></td>
     
     <td style={{  }}>
       <h2 className="fnav"  style={navLinkStyle}>TALK TO US</h2>
       <h2 className="fnav" style={navLinkStyle}>306.450.7700</h2>
       <h2 className="fnav" style={navLinkStyle}>understand@laroye.ai</h2>
       <h2 className="fnav"  style={navLinkStyle}>REGINA, SK</h2>
     </td>
     
     
     <td style={{ fontSize: "23px", display: 'flex', flexDirection: 'column' }}>
     <a className="fnav foottry" href="#tryitout" style={tryit}>TRY IT OUT!</a>
       <a className="fnav" href="about" style={navLinkStyle}>ABOUT</a>
       <a className="fnav" href="#appfeatures" style={navLinkStyle}>APP FEATURES</a>
       <a className="fnav" href="#contact" style={navLinkStyle}>CONTACT</a>

     </td>
     <td></td>
   </tr>
 </tbody>
</table>

 )
}

const navLinkStyle = {
    color: '#f3e3d1',
    textDecoration: 'none',
  
    margin: '0 0px',
    padding: '5px 10px',

    transition: 'background-color 0.3s',
  };

  const tryit = {
    color: '#ec6130',
    textDecoration: 'none',
  
    margin: '0 0px',
    padding: '5px 10px',

    transition: 'background-color 0.3s',
  }
  
export default Footer;